import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'app/services/alert.service';
import { ProductsService } from 'app/main/pages/products/product.service';
import { ConfirmActionDialogComponent } from '../confirm-action-dialog/confirm-action-dialog.component';

export interface UploadProductImageData {
  productId: number;
  productName: string;
  currentImageUrl?: string;
}

@Component({
  selector: 'app-upload-product-image-modal',
  templateUrl: './upload-product-image-modal.component.html',
  styleUrls: ['./upload-product-image-modal.component.scss']
})
export class UploadProductImageModalComponent implements OnInit {

  selectedFile: File | null = null;
  previewUrl: string | null = null;
  isLoading: boolean = false;
  hasCurrentImage: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<UploadProductImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadProductImageData,
    private _productService: ProductsService,
    private _alertService: AlertService,
    private _matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.data.currentImageUrl) {
      this.previewUrl = this.data.currentImageUrl;
      this.hasCurrentImage = true;
    }
  }

  onImageSelected(file: File | null): void {
    if (file) {
      this.selectedFile = file;
      // Criar preview local
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewUrl = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    } else {
      // Remover imagem
      this.selectedFile = null;
      this.previewUrl = null;
    }
  }

  save(): void {
    if (!this.selectedFile && !this.hasCurrentImage) {
      this._alertService.error('Selecione uma imagem para fazer upload.');
      return;
    }

    this.isLoading = true;

    if (this.selectedFile) {
      // Upload de nova imagem
      this._productService.changePhoto(this.data.productId, this.selectedFile).subscribe(
        (response) => {
          this._alertService.success('Imagem atualizada com sucesso!');
          this.dialogRef.close({ updated: true, imageUrl: response.image });
          this.isLoading = false;
        },
        (error) => {
          this._alertService.error(error || 'Erro ao fazer upload da imagem.');
          this.isLoading = false;
        }
      );
    } else if (!this.previewUrl && this.hasCurrentImage) {
      // Remover imagem existente
      this._alertService.success('Imagem removida.');
      this.dialogRef.close({ updated: true, imageUrl: null });
      this.isLoading = false;
    } else {
      // Nenhuma alteração
      this.dialogRef.close({ updated: false });
      this.isLoading = false;
    }
  }

  removeImage(): void {
    const dialogRef = this._matDialog.open(ConfirmActionDialogComponent, {
      width: '400px',
      data: {
        title: 'Remover imagem?',
        message: 'A imagem deste produto será removida.',
        yesText: 'Remover imagem',
        noText: 'Cancelar',
        confirmVariant: 'danger',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        
        // Fazer requisição para remover a imagem no backend
        this._productService.deletePhoto(this.data.productId).subscribe(
          (response) => {
            this._alertService.success('Imagem removida com sucesso!');
            this.dialogRef.close({ updated: true, imageUrl: null });
            this.isLoading = false;
          },
          (error) => {
            this._alertService.error(error || 'Erro ao remover a imagem.');
            this.isLoading = false;
          }
        );
      }
    });
  }

  cancel(): void {
    this.dialogRef.close({ updated: false });
  }
}
